import { FormatterCell, ValidatorFunc } from "../BaseTable";

export const isRequiredValidator: ValidatorFunc = (cell: FormatterCell) => {
	const value = cell.value;

	if (value === null || value === undefined || value === ''
		|| (value instanceof Map && value.size === 0)
		|| (value instanceof Set && value.size === 0)
		|| (value instanceof Array && value.length === 0)
	) {
		return {
			message: 'i18n.validator.required'
		}
	}

	return undefined;
}

// isUniqueFieldNameValidator za formu pogledaj ako treba
